export default __webpack_public_path__ + "b8882ba4164cf6760f24d2c3ace053ed.jpg";